// extracted by mini-css-extract-plugin
export default {"input-dropdown-popover":"input-dropdown-popover-30kcJ","form-control":"form-control-3iWBJ","input-label":"input-label-Z78jN","desktop-tooltip":"desktop-tooltip-10hhh"};